<template>
  <div>
    <div class="product-title">{{$t('product-title')}}</div>
    <p v-if="step">{{$t('step')}} {{ step }} / {{ nSteps }}</p>
    <div class="cost-wrapper" v-if="step">
<!--      <div class="cost-inner-wrapper">-->
<!--        <span>{{$t('estimated-cost')}} </span>-->
<!--        <span class="cost">-->
<!--          <template v-if="cost && cost > 0 && step > 2">-->
<!--            {{ cost.toLocaleString() }} €-->
<!--          </template>-->
<!--          <template v-else>-->
<!--            - -->
<!--          </template>-->
<!--        </span>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import { nSteps } from "@/utils/steps.js";

export default {
  name: "CalculatorHeading",
  props: {
    step: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      nSteps: nSteps()
    };
  },
  computed: {
    cost: function() {
      return this.$store.state.cost;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../common/_variables.scss";
.product-title {
  font-size: 18px;
  font-weight: 600;
  margin-top: 10px;
  margin-bottom: 0;
  color: $color-primary;
}
.cost {
  font-size: 18px;
  font-weight: bold;
  margin-left: 5px;
}
.cost-wrapper {
  text-align: center;
  display: flex;
}
.cost-inner-wrapper {
  padding: 10px 20px 10px 20px;
  background-color: transparentize($color-gray, 0.45);
  border-radius: 15px;
  margin: auto;
}
</style>
